var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-card"},[_c('div',{staticClass:"icon-card__icon"},[(_vm.type === 'warn' || _vm.type === 'succes')?_c('ErrorIcon',{class:{
        'icon--warn': _vm.type === 'warn',
        'icon--succes': _vm.type === 'succes'
      },attrs:{"customColor":""}}):_c('TestsIcon')],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }